<template>
  <div class="playing-as">
    <!-- <template v-if="currentUser == null || currentUser.displayName == ''">
      Playing as a Guest
    </template> -->

    <template
      v-if="currentUser != null && currentUser.displayName && userCanEditName"
    >
      Playing as
      <a class="img-a-button playing-as-name" @click="$emit('click')"
        >{{ currentUser.displayName }} <i class="fas fa-edit"></i
      ></a>
    </template>

    <template v-if="currentUser != null && !userCanEditName">
      Playing as
      <span class="highlighted-text playing-as-name">{{
        currentUser.displayName
      }}</span>
    </template>
  </div>
</template>

<script>
import { isTempUser } from "../../utils";
export default {
  props: ["currentUser"],
  computed: {
    userCanEditName() {
      return isTempUser(this.currentUser);
    }
  }
};
</script>

<style lang="scss" scoped>
.playing-as {
  padding: 0 60px;
  font-size: 0.5125rem;
  // margin-top: -5px;
  text-align: right;

  .img-a-button {
    margin: 0;
    padding: 0;
    &:hover {
      transform: none;
      box-shadow: none;
    }
  }

  .playing-as-name {
    display: inline-block;
    background: rgba(0, 0, 0, 0.35);
    border-radius: 10px;
    padding: 0px 8px 0px 10px;
    line-height: 24px;
  }

  [class*="fa-"] {
    font-size: 0.8rem;
  }
}

@media (max-width: 768px) {
  .playing-as {
    padding: 0 15px;
    margin-top: 4px;
  }
}
</style>